import styled from '@emotion/styled';

export const Icon = styled('img')`
  margin-right: ${(props) => props.theme.spacing(2)};
  width: ${(props) => `${props.size}px`};
  height: ${(props) => `${props.size}px`};
  margin-bottom: 32px;
`;
